import React, { Component } from 'react';
import authService from 'services/authService';
import UIComponent from 'components/UiComponent';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons/faEnvelope';
import { faLock } from '@fortawesome/free-solid-svg-icons/faLock';
import MedSISLogo from 'assets/images/medsis-ce-logo.png';
import Copyright from './components/Copyright';
import './authentication.less';
import MsgBox from 'sis_ui/modules/notifications';
import AppContext from 'components/appContext';
import { withRouter } from 'components/Routing';
import queryString from 'query-string'
import config from 'root/../config';
import {withTranslation} from "react-i18next";
import LoadingScreen from 'root/components/LoadingScreen/LoadingScreen';
import LoginButtonSwitch from './components/LoginButtonSwitch';

class AuthenticationPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            macidInProgress: false,
            goToMacID: false,
            ldapIdInProgress: false,
            ccIdInProgress: false
        }

        this._goToLdapID = this._goToLdapID.bind(this);
        this._goToMacID = this._goToMacID.bind(this);
        this._goToCCID = this._goToCCID.bind(this);
    }

    componentDidMount() {
        this.context.clearAppContext();
        this.setActiveState = null;
        
        if(this.props.router.location.pathname.includes("ldapId")){
            this.setState({
                ldapIdInProgress:true
            },() => {
                authService.setContext(this.context);
                authService.authenticateWithExternalId(queryString.parse(this.props.router.location.search)).then(() => {
                    this.props.router.navigate('/');

                }).catch((error) => {
                    this.setState({
                        ldapIdInProgress:false
                    },() => MsgBox.drawMessage("error",error))
                })
            })
        }

        if(this.props.router.location.pathname.includes("externalId")){
            this.setState({
                ccIdInProgress:true
            },() => {
                authService.setContext(this.context);
                authService.authenticateWithExternalId(queryString.parse(this.props.router.location.search)).then(() => {
                    this.props.router.navigate('/');

                }).catch((error) => {
                    this.setState({
                        ccIdInProgress:false
                    },() => MsgBox.drawMessage("error",error))
                })
            })
        }
        
        if(this.props.router.location.pathname.includes("macId")){
            this.setState({
                macidInProgress:true
            },() => {
                authService.setContext(this.context);
                authService.authenticateWithExternalId(queryString.parse(this.props.router.location.search)).then(() => {
                    this.props.router.navigate('/');

                }).catch((error) => {
                    this.setState({
                        macidInProgress:false
                    },() => MsgBox.drawMessage("error",error))
                })
            })
        }
    }
    
    _onSubmit({values, setError}) {
        authService.setContext(this.context);
        authService.logIn({username:values.username, password:values.password}).then((data)=>{
            this.props.router.navigate('/');
        }).catch(e => {
            if (e.hasOwnProperty("MESSAGE")) {
                e.MESSAGE.forEach((error)=>{
                    if(error.TAG != "") {
                        setError(error.TAG,error.MESSAGE);
                    } else {
                        MsgBox.drawMessage("error", error.MESSAGE)
                    }
                });
                if(this.setActiveState){
                    this.setActiveState("active");
                }
            }
        });
    }

    _goToMacID() {
        window.location.href = config.mainAppUrl + 'mcAuth/';
    }

    _goToLdapID(){
        authService.logOut();
    }

    _goToCCID(){
        window.location.href = config.mainAppUrl + 'externalAuth/';
    }

    _getExternalAuthButtonAction(type){
        switch(type){
            case "MacID":
                return this._goToMacID
            case "LdapID":
                return this._goToLdapID
            case "CCID":
                return this._goToCCID
        }
    }

    render() {
        return (
            <React.Fragment>
                {
                    this.state.ldapIdInProgress || this.state.ccIdInProgress || this.state.macidInProgress ? 
                    <LoadingScreen/>
                    :
                    <div className="authentication-scene full-height--with-policy flex-column row">                   
                    <div className="login__logo-container col-12">
                        {config.specifics.warningline && 
                        (
                            <div className="warningLineContainer">
                                {config.specifics.warningline}
                            </div>
                        )
                        }
                        <img alt="medsis" src={MedSISLogo} className="secondary-logo pr-2" />
                        <div className="logo-faculty pl-2">
                            {config.specifics.logoFaculty}<br />    
                            {config.specifics.logoUniversity}
                        </div>
                    </div>
                    <div className="login__buttons-container flex-fill justify-content-center align-items-center">
                        <div className="col">
                            <UIComponent 
                                component="smart-form"
                                values={{
                                    username: "",
                                    password: "",
                                }}
                                onSubmit={this._onSubmit.bind(this)}
                            >
                                <UIComponent
                                    component="smart-form-consumer"
                                >
                                    {({ setValue, submitForm }) => (
                                        <div className="col text-center">
                                            {config.externalAuth.isUsed && config.externalAuth.position == 'top' ? 
				                               <>
				                                   {config.externalAuth.description != '' ? 
				                                		<div className="external-auth-description">
				                                			{config.externalAuth.description}
				                                		</div>
				                            		: null
				                            		}
				                            		<div className="buttons__wrapper mb-5">
				                                        <React.Fragment>
				                                            <LoginButtonSwitch
				                                                type={config.externalAuth.type}
				                                                buttonType={config.externalAuth.buttonType}
				                                                onClick={this._getExternalAuthButtonAction(config.externalAuth.type)}
				                                                state = {this.state.ldapIdInProgress || this.state.macidInProgress}
				                                            />
				                                        </React.Fragment>
				                                    </div>
				                        		</>
                                            : null
                                            }
                                            
                                            { !config.disableNativeLogin ?
                                                <div className="inputs__wrapper mb-4">
                                                    <div className="input__wrapper">
                                                        <div className="input__icon-container"><FontAwesomeIcon icon={faEnvelope}/></div>
                                                    
                                                        <div className="input__container login-password-container input__with-icon">
                                                            <UIComponent 
                                                                component="smart-input" 
                                                                id="username"
                                                                name="username"
                                                                placeholder={" "} 
                                                                maxlength={200} 
                                                                type={"email"} 
                                                                customLabel={<label key={"email"} htmlFor="emailField">{this.props.t("lbl.USERNAME","Username")}</label>}
                                                                disabled={this.state.macidInProgress}
                                                                onChange={(e, value)=>{
                                                                    setValue('username', value)
                                                                }}
                                                                showErrors
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="input__wrapper mb-4">
                                                        <div className="input__icon-container"><FontAwesomeIcon icon={faLock}/></div>
                                                    
                                                        <div className="input__container login-password-container input__with-icon">
                                                            <UIComponent 
                                                                component="smart-input" 
                                                                id="password"
                                                                name="password"
                                                                placeholder={" "} 
                                                                maxlength={200} 
                                                                type={"password"} 
                                                                icon={<FontAwesomeIcon icon={faLock}/>} 
                                                                customLabel={<label key={"password"} 
                                                                htmlFor="passwordField">{this.props.t("lbl.PASSWORD","Password")}</label>}
                                                                disabled={this.state.macidInProgress}
                                                                onChange={(e, value) => {
                                                                    setValue('password', value)
                                                                }}
                                                                showErrors
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                :
                                                null
                                            }
                                            <div className="buttons__wrapper mb-4">
                                                {
                                                    !config.disableNativeLogin ?
                                                    <UIComponent
                                                        id="login"
                                                        component="smart-button"
                                                        class="btn btn__auth btn__no-border"
                                                        type="submit"
                                                        onClick={(event, setActiveState) =>  {
                                                            this.setActiveState = setActiveState;
                                                        }}
                                                        triggeredText={this.props.t("lbl.AUTHENTICATING","Authenticating...")}
                                                        state={this.state.macidInProgress ? "disabled" : "active"}
                                                   >
                                                        {this.props.t("lbl.LOGIN","Login")}
                                                    </UIComponent> 
                                                    :
                                                    null
                                                } 

												{config.externalAuth.isUsed && config.externalAuth.position == 'bottom' ?
													<>
														{!config.disableNativeLogin ?
		                                                    <div className="col mb-3 mt-2 font-weight-bold">{this.props.t("lbl.OR","OR")}</div>
		                                                    :
		                                                    null
														}
														{config.externalAuth.description != '' ? 
		                                            		<div className="external-auth-description">
		                                            			{config.externalAuth.description}
		                                            		</div>
	                                            		: null
														}
	                                            		
                                                        <React.Fragment>
                                                            <LoginButtonSwitch
                                                                type={config.externalAuth.type}
                                                                buttonType={config.externalAuth.buttonType}
                                                                onClick={this._getExternalAuthButtonAction(config.externalAuth.type)}
                                                                state = {this.state.ldapIdInProgress || this.state.macidInProgress}
                                                            />
                                                        </React.Fragment>
                                            		</>
                                            	: null
                                            	}
                                            </div>
                                        </div>
                                    )}
                                </UIComponent>
                            </UIComponent>
                            
                        </div>
                    </div>
                    <Copyright />
                </div>
                }
            </React.Fragment>
        )
    }
}

const AuthenticationPageWithRouter = withRouter(withTranslation()(AuthenticationPage));
export default AuthenticationPageWithRouter;
AuthenticationPage.contextType = AppContext;